"use strict";
const createSearchStringQuery = search => ({
    '$integration.name$': {
        iLike: `%${search.replace(' ', '')}%`,
    },
});
module.exports = createSearchStringQuery;
